<template>
	<div >
		<v-card >
			<s-toolbar
				:label="'Abastecimiento por QR - ' + selectedChamber?.ChaDescription + ' - ' + selectedChamber?.TypeFreshProductionDestinationText"	
				sync
				@sync="openDialog = true"
				dark color="#8e8f91"
			>
			</s-toolbar>
			<v-container>
				<v-row>
					<v-col cols="6">
						<s-select-definition
							:def="1181"
							label="Destino"
							@input="list_Chamber($event)"								
							v-model="TypeDestiny"
						/>
					</v-col>
					<v-col cols="6">
						<s-select
                              label="Cámara de Enfriamiento"
                              :items="listChamber"
                              autocomplete
                              item-text="ChaDescription"
                              item-value="ChaID"
                              v-model="chaID"
                              clearable
                          ></s-select>
					</v-col>
					<v-col cols="12">
						<s-scanner-qr
							:config="configScann"
							autofocus
							return-object
							@onValue="onValue($event)"
							@onData="onData($event)"
							:readonly="false"
						></s-scanner-qr>
					</v-col>
					<!-- <v-col cols="12">
						<chamber-rows-list v-if="chaID != 0" :ChaID="chaID" @select="selectrow($event)"></chamber-rows-list>
					</v-col>
					<v-col cols="12">
						<chamber-position-list v-if="chaID != 0" :ChaID="chaID" @select="selectPos($event)"></chamber-position-list>
					</v-col>
					<v-col cols="12">
						<chamber-column-list v-if="chaID != 0" :ChaID="chaID" @select="selectcol($event)"></chamber-column-list>
					</v-col> -->
				</v-row>
			</v-container>
		</v-card>   
        <!-- <v-dialog
			v-if="openDialog"
			v-model="openDialog"
			persistent
			width="70%">
			<supply-chamber-select @click="selectChamber($event)"></supply-chamber-select>
		</v-dialog> -->
	</div>
</template>

<script>
    import _sPrfChamberService from "@/services/FreshProduction/PrfChamberService";
	import _sPrfCoolingChamber from "@/services/FreshProduction/PrfCoolingChamberService";

    // import SupplyChamberSelect from "./SupplyChamberSelect.vue";
	import ChamberRowsList from "./ChamberRowsList.vue";
	import ChamberColumnList from "./ChamberColumnList.vue";
	import ChamberPositionList from "./ChamberPositionList.vue";
	// import _sLotProdCalibratedSupplyService from "../../../services/FreshProduction/PrfLotProdCalibratedSupplyService";
	// import _sLotProdCalibratedService from "../../../services/FreshProduction/PrfLotProductionCalibratedService";

	export default {
		components: {
            // SupplyChamberSelect,
			ChamberRowsList,
			ChamberColumnList,
			ChamberPositionList
        },
		data: () => ({
			Optional: 0,
            openDialog: true,
            selectedChamber: {},
			configScann: {},
			chaID : 0,
			PltID : 0,
			chcID : 0,
			chrID : 0,
			chpID : 0,
			listChamber: [],
			TypeDestiny: 0,
		}),
		watch: {
			chaID(){
				console.log("ccambio chaid", this.chaID)
				this.selectedChamber = this.listChamber.find(c => c.ChaID === this.chaID) || {};
			},		
		},
		methods: {
			list_Chamber(TypeDestiny){
				console.log("TypeDestiny",TypeDestiny);
				_sPrfChamberService.list({TypeDestiny},this.$fun.getUserID())
					.then(r => {
					console.log("chamber",r.data);
					this.listChamber = r.data;
					this.selectedChamber = this.listChamber[0] || null;
					this.chaID = this.selectedChamber?.ChaID || 0;
					})
			},
			// selectChamber(chamber){
            //     this.openDialog = false;

            //     this.selectedChamber = chamber;
			// 	this.chaID = chamber.ChaID;
            // },
			onValue(val) {
				 console.log("onvalue", val);
				 //aqui
				this.save(val);
			},

			onData(val) {
				console.log("onData", val);
			},
			selectrow(item){
				this.chrID = item.ChrID;
			},
			selectcol(item){
				this.chcID = item.ChcID;
			},
			selectPos(item){
				this.chpID = item.ChpID;
			},
			save(pltID){
				// this.$fun.alert("¿Seguro de pasar a Cámara?", "question")
				// 	.then((val) => {
				// 		if (val.value) {
							let coc = {
								PltID: pltID,
								ChaID: this.chaID,
								ChcID: null, //this.chcID,
								ChrID: null, // this.chrID,
								ChpID: null, // this.chpID,
								// TypeChamberTunnel: this.item.TypeChamberTunnel,
								CocStatus: 1,
								SecStatus: 1,
								UsrCreateID: this.$fun.getUserID(),
							};

							_sPrfCoolingChamber
								.save(coc, this.$fun.getUserID())
									.then((resp) => {
										if (resp.status == 200) { 
											this.$fun.alert( "Guardado Correctamente", "success" );
										}
									});
						// }
					// }) 
			}
		},
	};
</script>
